import { render } from "./OrgTypeView.vue?vue&type=template&id=27ecb01c&scoped=true"
import script from "./OrgTypeView.vue?vue&type=script&lang=js"
export * from "./OrgTypeView.vue?vue&type=script&lang=js"

import "./OrgTypeView.vue?vue&type=style&index=0&id=27ecb01c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27ecb01c"]])

export default __exports__